export default "__VITE_ASSET__LCFiLL$a__"